import Api from './api.service';

export default {
  login: (data) => Api.post('auth/login', data),
  logout: () => Api.post('auth/logout'),
  resetPassword: (data) => Api.put('auth/reset-password', data),
  sendResetLink: (data) => Api.post('auth/reset-password', data),
};
